export const CruzTm = () => {
  return <>Cruz<sup className='text-[9px]'>TM</sup></>
}